module.exports = __webpack_public_path__ + "4867cac1b8195bd92908a8d4b3509a3a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg21.jpeg
// module id = 30
// module chunks = 0